module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGklEQVR4nGOYOrntPyWYYdSAUQNGDRguBgAAJRGtH/aAKEcAAAAASUVORK5CYII="